<div class="form-container" [formGroup]="jobForm">
    <!-- <h2>Job Line Items</h2> -->
    <div class="product-row">
        <div class="row">
            <h3>General Info</h3>

            <!-- <div class="col-md-3 col-sm-6 mb-3 ">
            <div class="col-md-12">
                <b>Order Id<span style="color:red">*</span>: </b>
            </div>
            <div class="col-md-12">
                <span><input type="text" trim="blur" class="form-control"
                        formControlName="employeeCode" /></span>
            </div>
        </div> -->

            <!-- <div class="col-md-3 col-sm-6 mb-3 ">
            <div class="col-md-12">
                <b>Job Code<span style="color:red">*</span>: </b>
            </div>
            <div class="col-md-12">
                <span><input type="text" trim="blur" class="form-control"
                        formControlName="jobCode" /></span>
            </div>
        </div> -->
            <!-- <div class="col-md-3 col-sm-6 mb-3 ">
            <div class="col-md-12">
                <b>Customer Name<span style="color:red">*</span>: </b>
            </div>
            <div class="col-md-12">
                <span><input type="text" trim="blur" class="form-control" formControlName="accountId"
                        readonly /></span>
            </div>
        </div> -->
            <!-- <div class="col-md-3 col-sm-6 mb-3 ">
            <div class="col-md-12">
                <b>Customer<span style="color:red">*</span>: </b>
            </div>
            <div class="col-md-12">
                <ng-select [multiple]="false" formControlName="customerWarehouseId" appendTo="body" [ngClass]="editTrue ? 'disabled':''"
                    placeholder="" (ngModelChange)="onSelectWarehouseId($event)">
                    <ng-option *ngFor="let item of customerDetails?.accountLocationMappings"
                        [value]="item">{{item?.warehouseCode}}</ng-option>
                </ng-select>

            </div>
        </div> -->
            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>3PL <span style="color:red">*</span> </b>
                </div>
                <div class="col-md-12">
                    <!-- [ngClass]="editTrue ? 'disabled':''" -->
                    <ng-select [multiple]="false" formControlName="accountId" appendTo="body" 
                        placeholder="" >
                        <ng-option *ngFor="let item of customerDetails"
                            [value]="item?.id">{{item?.accountName}}</ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Tonnage <span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <input type="text" trim="blur" (keypress)="sharedService.isNumberOnly($event)"  class="form-control" formControlName="tonnage" />
                </div>
            </div>


            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Date/Time of Placement<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <p-calendar class="dateRange" formControlName="fromDate" [minDate]="minDate"
                        dateFormat="dd/mm/yy" [showTime]="true" [showIcon]="true" placeholder=""></p-calendar>

                </div>
            </div>

            <div class="col mb-3">
                <div class="col-md-12">
                    <b>Material Type<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <ng-select [multiple]="false" formControlName="materialTypeId" appendTo="body" 
                        placeholder="" >
                        <ng-option *ngFor="let item of materialTypeList"
                            [value]="item?.id">{{item?.name}}</ng-option>
                    </ng-select>                            
                </div>
            </div>
            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Remarks: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="text" trim="blur" class="form-control" formControlName="remarks" /></span>
                </div>
            </div>

            

        </div>

    </div>
    <div class="product-row">
        <div class="row">
            <h3>Customer POC Details</h3>
            <!-- <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Account Type <span style="color:red">*</span> </b>
                </div>
                <div class="col-md-12">
                    <ng-select [multiple]="false" formControlName="accountType" appendTo="body" 
                        placeholder="" >
                        <ng-option *ngFor="let item of customerPocDetails"
                            [value]="item?.id">{{item?.accountName}}</ng-option>
                    </ng-select>
                </div>
            </div> -->
            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Name<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="text" trim="blur" class="form-control" formControlName="contactName" /></span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Mobile<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="text" trim="blur" class="form-control" formControlName="contactMobile"
                            (keypress)="sharedService.isNumberKey($event)" maxlength="10" /></span>
                </div>
            </div>


            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Email<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="email" trim="blur" class="form-control" formControlName="contactEmail" /></span>
                </div>
            </div>
        </div>

    </div>

    <div class="product-row">
        <div class="row">
            <h3>3PL Contact Details</h3>

            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Name<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="text" trim="blur" class="form-control" formControlName="ascContactName" /></span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Mobile<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="text" trim="blur" class="form-control" formControlName="ascContactMobile"
                            (keypress)="sharedService.isNumberKey($event)" maxlength="10" /></span>
                </div>
            </div>


            <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Email<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <span><input type="email" trim="blur" class="form-control" formControlName="ascContactEmail" /></span>
                </div>
            </div>
        </div>

    </div>

    <div class="product-row" formArrayName="jobLineItems">
        <h3>Route Details</h3>
        <div class="col-md-3 col-sm-6 mb-3 ">
                <div class="col-md-12">
                    <b>Contract Type</b>
                </div>
                <div class="col-md-12 radio-button">
                    <label>
                        <input type="radio"  name="spotFlag" formControlName="spotFlag" 
                         [checked]="jobForm.get('spotFlag')?.value === false"
                            (change)="jobForm.get('spotFlag')?.setValue(false)" />
                        Contract
                    </label>

                    <label>
                        <input type="radio" name="spotFlag" formControlName="spotFlag" 
                        [checked]="jobForm.get('spotFlag')?.value === true"
                        (change)="jobForm.get('spotFlag')?.setValue(true)" />
                        Spot
                    </label>
                    
                </div>
            </div>
        <div *ngFor="let job of jobLineItems.controls; let i = index" [formGroupName]="i" class="job-card">

            <!-- <h3>Job Line Item {{ i + 1 }}</h3> -->
            <div class="form-row">
                <div class="row w-100">
                    <div class="row w-100">
                        <div class="col mb-3" *ngIf="jobForm.get('spotFlag')?.value === false || EditData?.spotFlag == false">
                            <div class="col-md-12">
                                <b>Route<span style="color:red">*</span>:</b>
                            </div>
                            <div class="col-md-12">
                                <ng-select [multiple]="false" formControlName="routeId" appendTo="body" placeholder="" (ngModelChange)="onSelectRoute($event)">
                                    <ng-option *ngFor="let route of routeList" [value]="route?.id">
                                        {{route?.routeCode}} {{route?.sourceCity}} - {{route?.destinationCity}}
                                    </ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <ng-container *ngIf="jobForm.get('spotFlag')?.value === true || EditData?.spotFlag == true">
                        <div class="col mb-3">
                            <div class="col-md-12">
                                <b>Source City<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                 <input type="text" trim="blur" class="form-control"
                                        formControlName="sourceText"  />

                                <!-- <ng-select [multiple]="false" formControlName="sourceId" appendTo="body"
                                    placeholder="">
                                    <ng-option *ngFor="let location of locationList" [value]="location?.id">
                                        {{location?.googleCityName}} </ng-option>
                                </ng-select> -->
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="col-md-12">
                                <b>Destination City<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                <input type="text" trim="blur" class="form-control"
                                        formControlName="destinationText" />

                                <!-- <ng-select [multiple]="false" formControlName="destinationId" appendTo="body"
                                    placeholder="">
                                    <ng-option *ngFor="let location of locationList" [value]="location?.id">{{
                                        location?.googleCityName}} </ng-option>
                                </ng-select> -->
                            </div>
                        </div>
                        </ng-container>
                        <div class="col mb-3">
                            <div class="col-md-12">
                                <b>Vehicle Type<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                               

                                <ng-select [multiple]="false" formControlName="vehicleTypeId" appendTo="body"
                                    placeholder="">
                                    <ng-option *ngFor="let vehicle of vehicleTypeList" [value]="vehicle?.id">{{
                                        vehicle?.vehicleType}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="col-md-12">
                                <b>No. of Vehicle<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                <span><input type="text" trim="blur" class="form-control"
                                        formControlName="numberOfVehicle"
                                        (keypress)="sharedService.isNumberOnly($event)" /></span>
                            </div>
                        </div>
                        <div class="col mb-0 position-relative">
                            <div class="col-md-12">
                                <b>Price</b>
                                <button type="button" class="remove-btn delete-route" (click)="removeJobLineItem(i)"><i
                                        title="Delete Row" class="pi pi-trash"></i></button>

                            </div>
                            <div class="col-md-12">
                                <span><input type="text" trim="blur" class="form-control"
                                        (keypress)="sharedService.isNumberOnly($event)"
                                        formControlName="maxSalary" /></span>
                            </div>
                        </div>
                        <!-- <div class="col-sm-2 mb-3">
                </div> -->




                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="row w-100">
                    <div class="col-sm-6">
                        <div class="location-block">
                            <h3>Pickup Location</h3>
                            <div class="row w-100" formArrayName="sourceCities">
                                <div class="row location-row"
                                    *ngFor="let sc of getSourceCities(i).controls; let j = index" [formGroupName]="j">
                                    
                                    <div class="col-sm-6 ">
                                        <!-- <div class="col-md-12">
                                            <b>Pincode<span style="color:red">*</span>: </b>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input formControlName="pincode" placeholder="Pincode" class="form-control" maxlength="6"  />
                                        </div>
                                    </div>
                                    <div class="col-sm-6 ">
                                        <!-- <div class="col-md-12">
                                            <b>City<span style="color:red">*</span>: </b>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input formControlName="city" placeholder="City" class="form-control"   />
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-6 mb-3" >
                            <div class="col-md-12">
                                <b>City Name<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                <input formControlName="cityName" class="form-control"  />
                            </div>
                        </div> 
                        <div class="col-sm-6" >
                            <div class="col-md-12">
                                <b>State Name<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                <input formControlName="stateName" class="form-control"  />
                            </div>
                        </div>  -->
                                    <div class="col-sm-12 mt-2">
                                        <!-- <div class="col-md-12">
                                            <b>Full Address<span style="color:red">*</span>: </b>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input formControlName="address" placeholder="Full Address" class="form-control"  />
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <button type="button" class="remove-btn minus" (click)="removeSourceCity(i, j)">
                                            <i title="Delete Row" class="pi pi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-primary add-points" (click)="addSourceCity(i)">+
                                    Pickup Point</button>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="location-block">
                            <h3>Drop Location</h3>
                            <div class="row w-100" formArrayName="destinationCities">
                                <div class="row location-row"
                                    *ngFor="let dc of getDestinationCities(i).controls; let k = index"
                                    [formGroupName]="k">
                                     <div class="col-sm-6 ">
                                        <!-- <div class="col-md-12">
                                            <b>Pincode<span style="color:red">*</span>: </b>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input formControlName="pincode" placeholder="Pincode" class="form-control" maxlength="6" />
                                        </div>
                                    </div>
                                    <div class="col-sm-6 ">
                                        <!-- <div class="col-md-12">
                                            <b>City<span style="color:red">*</span>: </b>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input formControlName="city" placeholder="City" class="form-control"  />
                                        </div>
                                    </div>
                                   

                                    <!-- <div class="col-sm-6 mb-3" >
                            <div class="col-md-12">
                                <b>City Name<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                <input formControlName="cityName" class="form-control"  />
                            </div>
                        </div> 
                        <div class="col-sm-6" >
                            <div class="col-md-12">
                                <b>State Name<span style="color:red">*</span>: </b>
                            </div>
                            <div class="col-md-12">
                                <input formControlName="stateName" class="form-control"  />
                            </div>
                        </div>  -->
                                    <div class="col-sm-12 mt-2">
                                        <!-- <div class="col-md-12">
                                            <b>Full Address<span style="color:red">*</span>: </b>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input formControlName="address" placeholder="Full Address" class="form-control"  />
                                        </div>
                                    </div>
                                    <div class="col-sm-2 mb-3">
                                        <button type="button" class="remove-btn minus"
                                            (click)="removeDestinationCity(i, k)">
                                            <i title="Delete Row" class="pi pi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-primary add-points"
                                    (click)="addDestinationCity(i)">+ Drop Point</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <button type="button" class="remove-btn" (click)="removeJobLineItem(i)">Remove Route</button> -->

        </div>
    </div>

    <!-- <button type="button" class="btn btn-primary" (click)="addJobLineItem()">+ Add Route</button> -->

    <br /><br />
    <button type="button" class="btn btn-primary" [disabled]="!jobForm.valid"  (click)="onSubmit()">Submit</button>
</div>